import React, { useState } from 'react';
import { FaCopy } from 'react-icons/fa';
import api from '../../api/api';
import AnimatedSaveButton from '../AnimatedSaveButton';
import { FileCleanupResult } from '../../model/FileCleanupResult';
import SortableTable from '../table/SortableTable';

const headers:string[] = [
   'Directory',
   'Filename',
   'Size',
]

const formatLength = (length:number, text:string):string => {
    return (length > 0 ? (length + ' ') : 'No ') + text;
}

const FileCleanupPage: React.FC = () => {
    const [fileCleanupResult, setFileCleanupResult] = useState<FileCleanupResult>();
    const [showTable, setShowTable] = useState<boolean>(false);
    const [showMissingOnDisk, setShowMissingOnDisk] = useState<boolean>(false);

    const fileCleanup = async ():Promise<boolean> => {
        setFileCleanupResult(undefined);
        let result = await api().getFileCleanupResult();
        setFileCleanupResult(result);
        return true;
    }

    const data:any[][] = [];
    let cleanupTotal = 0;
    let command = '';
    if(fileCleanupResult){
        for(let row of fileCleanupResult.onDiskButNotInDatabase){
            cleanupTotal += row.size;
            const arr:any = [
                row.directory,
                row.filename,
                row.size,
                row
            ]
            const filenamePart = !!row.filename ? `/${row.filename}` : ''
            command += `rm /opt/investi/wwwroot/announcements/${row.directory}${filenamePart}\n`
            data.push(arr)
        }
    }

    return <div className="padding">
        <h1>File Cleanup</h1>

        <div className="form-item">
            <AnimatedSaveButton onClick={fileCleanup} startingText="File Cleanup" progressText="Wait..." completedText="Done!" />
        </div>

        { fileCleanupResult && <>
            <h3>{formatLength(fileCleanupResult.missingOnDisk.length, 'Missing on Disk')}</h3>
            { fileCleanupResult.missingOnDisk.length > 0 && <>
                <button onClick={()=>setShowMissingOnDisk(!showMissingOnDisk)}>{showMissingOnDisk ? 'Hide' : 'Show'}</button>
                { showMissingOnDisk && <ul>
                    { fileCleanupResult.missingOnDisk.map((x,i) => <li key={i}>{x.filename}</li>)}
                </ul>}
            </>}

            <h3>{formatLength(fileCleanupResult.duplicates.length, 'Duplicates')}</h3>
            { fileCleanupResult.duplicates.length > 0 && <ul>
                { fileCleanupResult.duplicates.map((x,i) => <li key={i}>{x}</li>)}
            </ul>}

            <h3>{formatLength(fileCleanupResult.onDiskButNotInDatabase.length, 'Files To Delete')}</h3>
            { fileCleanupResult.onDiskButNotInDatabase.length > 0 && <>
                <p>Total Size: {Math.round(cleanupTotal/1024/1024).toLocaleString()} mB </p>
                <button onClick={()=>setShowTable(!showTable)}>Show Table</button>
                { showTable && <SortableTable headers={headers} data={data} />}

                <div style={{display:'flex', alignItems:'flex-start', gap:8}}>
                    <pre style={{flex:1, margin:0}}>{command}</pre>
                    <FaCopy
                        style={{cursor:'pointer', marginTop:4, opacity:0.5}}
                        title="Copy commands"
                        onClick={()=>navigator.clipboard.writeText(command)}
                    />
                </div>
            </>}
        </>}
    </div>
}

export default FileCleanupPage;
